export default "__VITE_ASSET__ClZxH_Yo__"